import React from "react";

function Bouns({ socialLinks, generel }) {
  const origin = window.location.origin.replace(/^https?:\/\/(aff\.)?/, '');

  return (
    <div className="et_pb_section et_pb_section_8_tb_body section_contactUS et_pb_with_background et_section_regular">
      <div className="et_pb_row et_pb_row_7_tb_body">
        <div className="et_pb_column et_pb_column_4_4 et_pb_column_8_tb_body et_pb_css_mix_blend_mode_passthrough et-last-child">
          <div className="et_pb_module et_pb_text et_pb_text_3_tb_body et_pb_text_align_center et_pb_bg_layout_light">
            <div className="et_pb_text_inner">
              <h1 style={{ textAlign: 'center' }}>
                SIGN UP TODAY AT {origin} AFFILIATES AND START<br />
                <span className="yellow-color">EARNING UNLIMITED COMMISSION!</span>
              </h1>
              <p>
                Need assistance on how to create an account?<br />
                Are you already an affiliate and want to get in touch with us?
              </p>
            </div>
          </div>
          <div className="et_pb_module et_pb_code et_pb_code_0_tb_body">
            <div className="et_pb_code_inner">
              <div className="clearfix">
                <div className="button">
                  <a href={socialLinks?.telegram} target="_blank" className="telegram" rel="noopener noreferrer">Telegram</a>
                  <a href={`mailto:affiliates@${origin}`} target="_blank" className="email" rel="noopener noreferrer">Email</a>
                  <a href="/signup" className="register">Sign Up</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Bouns;
